import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-agregar-observacion',
  templateUrl: './modal-agregar-observacion.component.html',
  styleUrls: ['./modal-agregar-observacion.component.scss']
})
export class ModalAgregarObservacionComponent implements OnInit {

  articuloOpened: any;
  observacion: string = '';
  
  private ultimoArticuloKey: string = '';
  private debeCargarObservacion: boolean = true;

  constructor(
    public genServ: EcommerceGenericoService,
    private modal: ModalService,
  ) {}

  private ultimoCodigoArticulo: number = 0;

  ngOnInit(): void {
  }

  cargarObservacion(): void {
    this.observacion = this.articulo?.getObservacion?.() || '';
  }

  guardar(): void {
    const art = this.articulo;
  
    if (!art) {
      this.debeCargarObservacion = true;
      this.modal.closeAll();
      return;
    }
  
    art.setObservacion(this.observacion || '');
  
    this.genServ.sincronizarCarritoFrontyBack();
  
    this.debeCargarObservacion = true;
    this.modal.closeAll();
  }

  closeModal(): void {
    this.modal.closeAll();
  }

  cancelar(): void {
    this.debeCargarObservacion = true;
    this.modal.closeAll();
  }

  get articulo() {
    const art = this.genServ.getArticuloObservacion();
  
    if (!art) {
      return undefined;
    }
  
    const keyArticulo = `${art.getMarca()}-${art.getCodigo()}`;
  
    if (keyArticulo !== this.ultimoArticuloKey || this.debeCargarObservacion) {
      this.ultimoArticuloKey = keyArticulo;
  
      // Si el artículo tiene observación, la muestra.
      // Si no tiene, queda vacío y se ve el placeholder.
      this.observacion = art.getObservacion?.() || '';
  
      this.debeCargarObservacion = false;
    }
  
    return art;
  }
}